import * as React from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import parse from 'html-react-parser';


export interface componentProps {
	needle: string;
	owner: object;
	projects: object;
}

export default function CardOwner(props: componentProps) {
		
	const {needle, owner, projects, onEdit} = props;

	const highlight = (str, group1, group2)=>{
		return "<span class=bg-warning>"+str+"</span>";
	}
	return(
		<Card className="card card-owner m-2">
			<Card.Header>
				<h6 className="card-title">
					{parse(owner.name.replace(new RegExp(needle, "i"), highlight))} <Link className="me-5" title="Edit" onClick={onEdit}><i className="ri-pencil-line" /></Link>
					{projects ? projects : ''}
				</h6>
			</Card.Header>
			<Card.Body>
				<Row>
					<Col xs="4">
						<div className="fw-bold">Email</div>
						<div>{owner.email ? parse(owner.email.replace(new RegExp(needle, "i"), highlight)) : ' '} &nbsp;</div>
					</Col>

					<Col xs="4">
						<div className="fw-bold">Phone</div>
						<div>{owner.phone ? parse(owner.phone.replace(new RegExp(needle, "i"), highlight)) : ' '} &nbsp;</div>
					</Col>
					<Col xs="4">
						<div className="fw-bold">Address</div>
						<div>{owner.address ? parse(owner.address.replace(new RegExp(needle, "i"), highlight)) : ' '} &nbsp;</div>
					</Col>
				</Row>



			</Card.Body>
		</Card>
	)
}